const httpToHttps = ( url ) => {
    return url && url.match( '^http://' ) ? url.replace( 'http://', 'https://' ) : url
}

function formatNumber( number ) {
    number = Number( number ) || 0
    return number > 100000 ? `${Math.round( number / 10000 )}` : number
}

function formatDate( date, fmt = "yyyy-MM-dd hh:mm:ss" ) {
    date = date instanceof Date ? date : new Date( date )
    if ( /(y+)/.test( fmt ) ) {
        fmt = fmt.replace( RegExp.$1, ( date.getFullYear() + "" ).substr( 4 - RegExp.$1.length ) )
    }
    let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
    }
    for ( let k in o ) {
        if ( new RegExp( `(${k})` ).test( fmt ) ) {
            let str = o[k] + ""
            fmt = fmt.replace( RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero( str ) )
        }
    }
    return fmt
}

function padLeftZero( str ) {
    return ( "00" + str ).substr( str.length )
}

function getDateFormat( date ) {
    date = new Date( date ).toLocaleDateString()
    return date
}

const convertPlayedCount = ( count ) => {
    if ( count >= 1000 * 1000 ) {
        return (
            ( count / 1000000 )
                .toFixed( 3 )
                .slice( 0, 3 )
                .replace( /\.$/, "" ) + " " + `M`
        )
    } else if ( count >= 1000 ) {
        return (
            parseInt( count / 1000 )
                .toFixed( 3 )
                .slice( 0, 3 )
                .replace( /\.$/, "" ) + " " + `K`
        )
    }
    return count
}

export {
    httpToHttps,
    formatNumber,
    formatDate,
    getDateFormat,
    convertPlayedCount
}